<div class="text-center">
  <p class="text-slate-600 mb-1 text-sm sm:text-base">Hemos enviado un código OTP a:</p>
  <p class="font-bold text-slate-800 mb-4 text-base sm:text-lg break-all">{{ email }}</p>
  <p class="text-slate-600 mb-5 text-sm sm:text-base">Por favor, ingrésalo a continuación.</p>

  <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="w-full my-5" appearance="outline">
      <mat-label>Código OTP</mat-label>
      <input matInput formControlName="otp" type="text" placeholder="XXXXXX" maxlength="6" [disabled]="disabled" required>
      @if (otpForm.get('otp')?.invalid && otpForm.get('otp')?.touched) {
        <mat-error>
          Por favor, ingrese un código OTP válido (6 dígitos).
        </mat-error>
      }
    </mat-form-field>

    <button mat-raised-button 
            type="submit" 
            [disabled]="otpForm.invalid || disabled" 
            class="w-full mb-4 bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 sm:py-3 px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base">
      Verificar OTP
    </button>

    <button mat-button 
            type="button" 
            (click)="onBackToEmail()" 
            [disabled]="disabled" 
            class="w-full text-slate-800 border border-slate-300 bg-transparent hover:bg-slate-50 py-2 sm:py-3 px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base">
      Volver a ingresar email
    </button>
  </form>
</div>